import { Button, WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import Progress from 'src/components/Progress';
import QuickModeTest from 'src/components/QuickModeTest';
import QuickModeText from 'src/components/QuickModeText';
import { IRootState } from 'src/reducers';
import { IMessage } from '../actions/message';
import * as Actions from '../actions/quickModeContens';
import MessageDialog from '../components/MessageDialog';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IContentsTextInfo,
	ICourseInfo,
} from '../scenario/QuickModeContentsScenarioFactory';
import { Routes, Screens } from '../utils/Routes';
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		buttonWrapper: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
			marginTop: '10px',
		},
		button_confirm: {
			backgroundColor: '#516ecb',
			borderRadius: '10px',
			fontSize: '1.2rem',
			height: '50px',
			width: '250px',
		},
		button_finish: {
			'&:hover': {
				backgroundColor: '#5c9128',
			},
			backgroundColor: '#6fb727',
			borderRadius: '10px',
			fontSize: '1.2rem',
			height: '50px',
			width: '150px',
		},
		image_next: {
			'@media (max-width: 600px)': {
				width: '25px',
			},
			width: '65px',
		},
		nextDiv: {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
			marginBottom: '10px',
			marginTop: '10px',
		},
		previewDialog: {
			width: '80%',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IState {
	quickModePreview: boolean;
	messages: IMessage[];
	openDialog: boolean;
	exportResultDialog: boolean;
	loading: boolean;
	redirect: boolean;
	resultOK: boolean;
}

class QuickModeTextAndTestCreate extends React.Component<IProps, IState> {
	protected uploadInput: React.RefObject<HTMLInputElement>;
	public constructor(props: IProps) {
		super(props);
		this.state = {
			exportResultDialog: false,
			loading: false,
			messages: [],
			openDialog: false,
			quickModePreview: false,
			redirect: true,
			resultOK: false,
		};
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.exportResultDialogClose = this.exportResultDialogClose.bind(this);
	}

	public componentDidMount() {
		const { initFlg } = this.props.location.state;
		if (!initFlg) {
			this.props.saveTest(null, '');
			this.props.saveTemplateData(null);
			this.props.saveText([]);
		}
		this.props.reSetCurrentItem();
	}

	public render() {
		const { classes } = this.props;
		const viewItem: string[] = this.props.viewItem;
		const { initFlg } = this.props.location.state;
		return (
			<>
				<div className={classes.root}>
					<Progress open={this.state.loading} />
					<div className={classes.wrapDiv}>
						{viewItem.includes('TEXT') && (
							<QuickModeText initFlg={initFlg} />
						)}
						{viewItem.includes('TEXT') &&
							viewItem.includes('TEST') && (
								<div className={classes.nextDiv}>
									<img
										src={require('../images/Next2.png')}
										className={classes.image_next}
									/>
								</div>
							)}
						{viewItem.includes('TEST') && (
							<QuickModeTest initFlg={initFlg} />
						)}
						<div className={classes.buttonWrapper}>
							<Button
								variant="contained"
								color="primary"
								className={classes.button_confirm}
								onClick={this.openPreview}
							>
								{i18n.t('QuickModeTextAndTestCreate_0000')}
							</Button>
						</div>
						<div className={classes.buttonWrapper}>
							<Button
								variant="contained"
								color="primary"
								className={classes.button_finish}
								onClick={this.exportCourse}
							>
								{i18n.t('QuickModeTextAndTestCreate_0001')}
							</Button>
						</div>
					</div>
				</div>
				<MessageDialog
					open={this.state.openDialog}
					showCancelButton={false}
					title={i18n.t('QuickModeTextAndTestCreate_0002')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
				<MessageDialog
					open={this.state.exportResultDialog}
					showCancelButton={false}
					title={
						this.state.resultOK
							? i18n.t('QuickModeTextAndTestCreate_0005')
							: i18n.t('QuickModeTextAndTestCreate_0002')
					}
					contents={this.state.messages}
					onClose={this.exportResultDialogClose}
					onClickOk={this.exportResultDialogClose}
				/>
			</>
		);
	}

	protected errorMessageDialogClose() {
		this.setState({ openDialog: false, messages: [] });
	}

	protected exportResultDialogClose() {
		this.setState({
			exportResultDialog: false,
			messages: [],
			openDialog: false,
			resultOK: false,
		});
		if (this.state.redirect) {
			const to = Routes.getPath(Screens.QUICK_MODE_CONTENTS_CREATE);
			this.props.pushHistory(to);
		}
		this.setState({
			redirect: true,
		});
	}

	protected contentsCheck(preview: boolean) {
		const { text, test } = this.props;
		const viewItem: string[] = this.props.viewItem;
		const messages: IMessage[] = [];
		if (viewItem.length === 2) {
			if (text.length === 0 && test === null) {
				// 取込ファイルをアップロードしてください。
				const message: IMessage = {
					content: 'CHK_E_0042',
					replacements: [],
				};
				messages.push(message);
				this.setState({
					messages,
					openDialog: true,
				});
				return false;
			}
			if (text.length === 0 && test !== null) {
				if (preview) {
					return true;
				}
				// テキストの取込ファイルをアップロードしてください。
				const message: IMessage = {
					content: 'CHK_E_0041',
					replacements: [i18n.t('QuickModeTextAndTestCreate_0004')],
				};
				messages.push(message);
				this.setState({
					messages,
					openDialog: true,
				});
				return false;
			}
			if (text.length !== 0 && test === null) {
				if (preview) {
					return true;
				}
				// テストの取込ファイルをアップロードしてください。
				const message: IMessage = {
					content: 'CHK_E_0041',
					replacements: [i18n.t('QuickModeTextAndTestCreate_0003')],
				};
				messages.push(message);
				this.setState({
					messages,
					openDialog: true,
				});
				return false;
			}
		} else {
			if (viewItem.includes('TEXT')) {
				if (text.length === 0) {
					// テキストの取込ファイルをアップロードしてください。
					const message: IMessage = {
						content: 'CHK_E_0041',
						replacements: [
							i18n.t('QuickModeTextAndTestCreate_0004'),
						],
					};
					messages.push(message);
					this.setState({
						messages,
						openDialog: true,
					});
					return false;
				}
			} else if (viewItem.includes('TEST')) {
				if (test === null) {
					// テストの取込ファイルをアップロードしてください。
					const message: IMessage = {
						content: 'CHK_E_0041',
						replacements: [
							i18n.t('QuickModeTextAndTestCreate_0003'),
						],
					};
					messages.push(message);
					this.setState({
						messages,
						openDialog: true,
					});
					return false;
				}
			}
		}
		return true;
	}

	protected openPreview = () => {
		if (this.contentsCheck(true)) {
			const to = Routes.getPath(Screens.QUICK_MODE_PREVIEW);
			this.props.pushHistory(to);
		}
	};

	protected exportCourse = () => {
		if (!this.contentsCheck(false)) {
			return;
		}
		const viewItem: string[] = this.props.viewItem;
		const textList: IContentsTextInfo[] = [];
		let testModel: Actions.ITestInfo | null = null;
		if (viewItem.includes('TEXT')) {
			if (this.props.text.length > 0) {
				this.props.text.forEach(item => {
					const text = {
						fileName: item.htmlFile.fileName,
						filePath: item.htmlFile.filePath,
						resourceFolder: item.htmlFile.resourceFolder,
					};
					textList.push(text);
				});
			}
		}
		if (viewItem.includes('TEST')) {
			if (this.props.test !== null) {
				testModel = this.props.test;
			}
		}
		const param = {
			courseFolder: this.props.courseFolder,
			courseName: this.props.courseName.trim(),
			orgId: this.props.orgId,
			testModel,
			textList,
		};
		this.setState({
			loading: true,
		});
		this.props.createExportCourse(this.props.token, param).then(data => {
			this.setState({
				loading: false,
			});
			const messages: IMessage[] = [];
			if (data) {
				if (data.messageId === 'LMCM_E_00048') {
					const message: IMessage = {
						content: 'LMCM_E_00048',
						replacements: [],
					};
					messages.push(message);
					this.setState({
						exportResultDialog: true,
						messages,
						redirect: false,
					});
				} else {
					if (data.status === '0') {
						// コンテンツを作成しました。
						const message: IMessage = {
							content: 'LMCM_E_16027',
							replacements: [],
						};
						messages.push(message);
						this.setState({
							exportResultDialog: true,
							messages,
							resultOK: true,
						});
					} else if (data.status === '1') {
						// コンテンツの登録に失敗しました。
						const message: IMessage = {
							content: 'LMCM_E_16028',
							replacements: [],
						};
						messages.push(message);
						this.setState({
							exportResultDialog: true,
							messages,
						});
					}
				}
			} else {
				const to = Routes.getPath(Screens.QUICK_MODE_CONTENTS_CREATE);
				this.props.pushHistory(to);
			}
		});
	};
}

const mapStateToProps = (state: IRootState) => ({
	courseFolder: state.quickModeContents.courseFolder,
	courseName: state.quickModeContents.courseName,
	orgId: state.quickModeContents.orgId,
	test: state.quickModeContents.test,
	text: state.quickModeContents.text,
	token: state.session.token,
	userAttr: state.session.userAttr,
	viewItem: state.quickModeContents.viewItem,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	createExportCourse: (token: string, param: ICourseInfo) => {
		const s = ScenarioFactory.createExportCourse(dispatch, token);
		return s.run(param);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	reSetCurrentItem: () => {
		dispatch(Actions.reSetCurrentItem({}));
	},
	saveTemplateData: (templateData: Actions.ITestInfo | null) => {
		dispatch(Actions.setTestData({ templateData }));
	},
	saveTest: (file: File | null, fileName: string) => {
		dispatch(Actions.setTestFile({ file, fileName }));
	},
	saveText: (files: Actions.IFileInfo[]) => {
		dispatch(Actions.setText({ files }));
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

interface IRouteState {
	initFlg: boolean;
}

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<{}, StaticContext, IRouteState>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeTextAndTestCreate);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeTextAndTestCreate.tsx